import axios from "../../api/hbscan";
import IProfile from "../../models/profile";
import ITask from "../../models/task";
import Auth from "../auth/AuthService";

class TaskService {
    GetTasks = async () => {
        const URI = `api/hbscan/task/GetTasks`;
        return (
            await axios.get<ITask[]>(URI, {
                headers: {
                    Authorization: Auth.guid,
                },
            })
        ).data || [];
    };

    GetProfilesByTaskId = async (taskId: number) => {
        const URI = `api/hbscan/ProfileTask/GetProfilesByTaskId`;
        return (
            await axios.get<IProfile[]>(URI, {
                params: {
                    taskId,
                },
                headers: {
                    Authorization: Auth.guid,
                },
            })
        ).data || [];
    };

    PostTask = async (task: ITask) => {
        const URL = `/api/hbscan/task/PostTask`;

        return (
            await axios.post<number>(URL, JSON.stringify(task), {
                headers: { Authorization: Auth.guid },
            })
        ).data;
    };

    PutTask = async (task: ITask) => {
        const URL = `/api/hbscan/task/PutTask`;

        return (
            await axios.put(URL, JSON.stringify(task), {
                headers: { Authorization: Auth.guid },
            })
        ).data;
    };
}
const taskService = new TaskService();

export default taskService;
